/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Injector, Input } from '@angular/core';
import { type Command, type PromptConfigFull, DeleteAbstract, UtilService } from '@dm/core';
import { type CIFSShare, type ExtensionFiltering, type NFSShare } from 'app/common/types/mo';

import { ExtensionFilteringStrService } from '../extension-filtering-str.service';
import { ExtensionFilteringService } from '../extenxion-filtering.service';

@Component({
    selector: 'app-delete-extension-filtering',
    templateUrl: './delete-extension-filtering.component.html',
    styleUrls: ['./delete-extension-filtering.component.scss'],
})
export class DeleteExtensionFilteringComponent extends DeleteAbstract<ExtensionFiltering> {
    @Input() share: CIFSShare | NFSShare;
    i18n = this.str.i18n;

    constructor(
        injector: Injector,
        private str: ExtensionFilteringStrService,
        private service: ExtensionFilteringService,
        private utilService: UtilService,
    ) {
        super(injector);
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'FILEEXTENSIONNAME',
                header: this.i18n.fileNameExtension,
            },
            {
                field: 'ID',
                header: this.i18n.id,
            },
            {
                field: 'RULETYPE',
                header: this.i18n.ruleType,
                render: (value) => this.utilService.getLabelFromOptions(this.str.ruleTypeOpt, value),
            },
        ];
    }

    prompt(): PromptConfigFull[] {
        const prompts: PromptConfigFull[] = [
            {
                opType: 'promptConfirm',
                title: this.i18n.deleteExtensionFilteringTitle,
                content: this.i18n.deleteExtensionFilteringTip,
                templateRef: this.tableTemplate,
                width: 700,
            },
        ];

        return prompts;
    }

    buildCmds(): Command[] {
        const cmds: Command[] = this.dataList.map((a: ExtensionFiltering) => ({
            name: this.i18n.deleteExtensionFilteringAction(a.FILEEXTENSIONNAME),
            action: this.service.deleteExtensionFiltering(a.ID, this.share.vstoreId),
        }));

        return cmds;
    }
}
